module.exports = __webpack_public_path__ + "img/xianshangyizhen.ba5dbd4f.png";